import { IGetDashboardFinanceiroInfosUseCaseUseCase } from "../../../presentation/useCases/read/get_dashboard_financeiro_infos_use_case_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { DashboardFinanceiroInfos } from "../../models/dashboard_financeiro_infos";

/**
 * GetDashboardFinanceiroInfosUseCaseUseCase
 */

export class GetDashboardFinanceiroInfosUseCaseUseCase implements IGetDashboardFinanceiroInfosUseCaseUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(): Promise<DashboardFinanceiroInfos> {
    return await this.repository.getDashboardFinanceiroInfos();

  }
}
